import {Affix, FloatButton} from 'antd';
import {useEffect, useState} from 'react';
import '../ContentIndex.css';
const logoImg = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/logo2.png';
const img1 = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/xm/lixue.jpg';
const img2 = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/xm/lixue2.jpg';
const logo22 = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/logo22.png';
const weixing = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/weixing.jpg';
const App = () => {
    useEffect(() => {
        // 配置swiper播放 配置项都写这里面
        // console.log(1232112312)
        // const mySwiper = new Swiper('.swiper', {
        //     autoplay: true,
        //     loop: true
        // })
        window.scrollTo(0, 0);

    }, [])
    const [scrollPosition, setScrollPosition] = useState(0);
    const [top, setTop] = useState(118);
    const scroll=(y)=>{
        window.scrollTo(0, y);
    }
    function createMarkup() {
        return {
            __html: `<div class="nyrcon">
                    <img src="`+img1+`" alt="力学试验" class="pprr">
                    <div class="nyrt"><h1 class="contact-tit">力学试验</h1></div>
                    <div class="cc-pp">
                        <h2><span style="font-size: 16px; color: rgb(0, 0, 0);">力学试验介绍</span></h2><p><span style="color: rgb(0, 0, 0);">金属</span><a  target="_self" style="color: rgb(0, 0, 0); text-decoration: underline;"><span style="color: rgb(0, 0, 0);">力学试验</span></a><span style="color: rgb(0, 0, 0);">，也就是通常所说的物理机械性能试验，机械性能是金属材料的常用指标的一个集合。在机械制造业中，一般机械零件都是在常温、常压和非强烈腐蚀性介质中使用的，且在使用过程中各机械零件都将承受不同载荷的作用。金属材料在载荷作用下抵抗破坏的性能，称为机械性能（或称为力学性能）。金属材料使用性能的好坏，决定了它的使用范围与使用寿命。金属材料的机械性能是零件的设计和选材时的主要依据。外加载荷性质不同（例如拉伸、压缩、扭转、冲击、循环载荷等），对金属材料要求的机械性能也将不同。常用的机械性能包括：强度、塑性、硬度、冲击韧性、多次冲击抗力和疲劳极限等。</span></p><p style="text-align: center;"><img src="`+img2+`" title="拉力试验" alt="拉力试验" width="342" height="227"></p><h2><span style="font-size: 16px; color: rgb(0, 0, 0);">力学试验类型</span></h2><p><span style="color: rgb(0, 0, 0);">一、</span><a  style="color: rgb(0, 0, 0); text-decoration: underline;"><span style="color: rgb(0, 0, 0);">硬度试验</span></a></p><p><span style="color: rgb(0, 0, 0);">硬度：衡量材料软硬程度的一种性能。其物理意义随试验方法不同而不同。</span></p><p><span style="color: rgb(0, 0, 0);">二、</span><a  target="_self" style="color: rgb(0, 0, 0); text-decoration: underline;"><span style="color: rgb(0, 0, 0);">拉伸试验</span></a></p><p><span style="color: rgb(0, 0, 0);">拉伸试验是其中一种最常用的试验方法，用于测定试样在受到轴向拉伸载荷后的行为。这些试验类型可在室温或受控(加热或制冷)条件下进行，以确定材料的拉伸性能。</span></p><p><span style="color: rgb(0, 0, 0);">三、压缩试验</span></p><p><span style="color: rgb(0, 0, 0);">压缩试验是一种常用于测定材料的压缩负载或抗压性的试验方法，同时也用于测定材料在受到一个特定的压缩负载并保持一段设定时间后的恢复能力。压缩试验用于测定材料在加载下的行为。此外也可测定一段时间内材料在(恒定或递增)载荷下可承受的最大应力。</span></p><p><span style="color: rgb(0, 0, 0);">四、</span><a  target="_self" style="color: rgb(0, 0, 0); text-decoration: underline;"><span style="color: rgb(0, 0, 0);">弯曲试验</span></a></p><p><span style="color: rgb(0, 0, 0);">弯曲试验是材料机械性能试验的基本方法之一，其测定材料承受弯曲载荷时的力学特性的试验。</span></p><p><span style="color: rgb(0, 0, 0);">五、</span><a  style="color: rgb(0, 0, 0); text-decoration: underline;"><span style="color: rgb(0, 0, 0);">冲击试验</span></a></p><p><span style="color: rgb(0, 0, 0);">冲击试验一般是确定军用、民用设备在经受外力冲撞或作用时产品的安全性、可靠性和有效性的一种试验方法。</span></p><p><span style="color: rgb(0, 0, 0);">六、疲劳试验</span></p><p><span style="color: rgb(0, 0, 0);">疲劳试验用以测定材料或结构疲劳应力或应变循环数的过程。</span></p>                    </div>
                </div>`
        };
    }

    return (

        <>
            <FloatButton.BackTop visibilityHeight={0}  style={{zIndex:9999999999999999}}/>
            <div className="fixed is_PC"></div>
            <div className="all_width is_PC">

                <div className="warp">
                    <div className="header">
                         <div className="logo"><a href="#/ContentIndex" style={{float:"left",marginRight:15}}><img src={logoImg} height={108}/></a></div>
                        <div className="new_nav">
                           <ul>
                                <li><a href="#/ContentIndex">首页</a></li>
                                <li><a  href="#/cnas">CNAS认可</a></li>
                                <li><a  href="#/cma">CMA认定</a></li>
                                <li><a  href="#/fanghuo">防火检测</a></li>
                                <li><a  href="#/haishui">海水腐蚀</a></li>
                                <li><a  href="#/jingxiang">金相抛光布</a></li>
                                <li><a   href="#/about">关于我们</a></li>
                            </ul>
                        </div>
                        <div className="vub_B" style={{position:"fixed",top:"30px"}}>联系电话： 18957441030</div>
                    </div>
                </div>
            </div>
            {/*<img src={yemei}/>*/}

            <div className={'service-details'} >
                <Affix offsetTop={top}>
                    <div className="l-box" >
                        <div className="s-plate">
                            <div className="d-nav">
                                <ul>
                                    <li onClick={event => scroll(435)}>
												<span>
													<i></i>力学试验介绍</span>
                                    </li>
                                    <li onClick={event => scroll(855)}>
												<span>
													<i></i>力学试验类型</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </Affix>
                <div className={'r-box'}>
                    <div dangerouslySetInnerHTML={createMarkup()}/>
                </div>
            </div>
            {/*<img src={xia} width={'100%'} style={{zIndex:999,position:"relative",marginTop:80,display:"block"}}/>*/}

             <div className="all_fnav is_PC" style={{zIndex:999,position:"relative"}}>
                 <div style={{background:'#fff',height:80}}></div>
                <div className="warp">
                    <div className={'b'}>
                        <img src={logo22} height={108} style={{float:"left"}}/>
                        <div style={{float:"right",lineHeight:'108px',fontSize:'26px',paddingRight:40}}>致力于我国实验室建设、 认证、 扩项、 监督评审、 一站式解决方案</div>
                    </div>
                    <div className="Fanya_footer_nav" style={{color:'#FFF'}}>
                        <ul>
                            <li>
                                
                                <div className="Fanya_footer_nav_TT">CMA资质认定</div>
                                <div className="Fanya_footer_sub">
                                    <dl>
                                        <dt>检验检测机构CMA资质认定</dt>
                                        <dt>机动车检验机构CMA资质认定</dt>
                                        <dt>司法鉴定机构CMA资质认定</dt>
                                        <dt>刑事技术机构CMA资质认定</dt>
                                    </dl>
                                </div>
                            </li>
                            <li><div className="Fanya_footer_nav_TT">CNAS认证认可</div>
                                <div className="Fanya_footer_sub">
                                    <dl>
                                        <dt>ISO17025检测/校准实验室CNAS认可</dt>
                                        <dt>ISO17020检验机构CNAS认可</dt>
                                        <dt>ISO15189医学实验室CNAS认可</dt>
                                        <dt>DILAC国防实验室认可</dt>
                                    </dl>
                                </div>
                            </li>
                            <li style={{marginRight:15}}>
                                <div className="Fanya_footer_nav_TT">联系我们</div>
                                <div className="Fanya_footer_sub">
                                    <dl>
                                        <dt>电话：0574-87636695</dt>
                                        <dt>认证热线：18957441030（胡老师）</dt>
                                        <dt>地址：宁波市高新区检验检测园冬青路258号A幢</dt>
                                        <dt></dt>
                                    </dl>
                                </div>
                            </li>
                            <li>
                                <div className="Fanya_footer_sub" style={{position:"relative"}}>
                                    <img src={weixing} width={160} />
                                    <div style={{background:'red',borderRadius:16,lineHeight:'32px',textAlign:"center",width:160,marginTop:10}}>扫码咨询</div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="all_Fanya_copyright">
                <div className="warp">
                    <div className="Fanya_copyright">版权所有 ◎ 浙江安鉴检测认证服务有限公司 <a
                        href="http://beian.miit.gov.cn/" target="_blank">浙ICP备2024103308号-1</a></div>
                </div>
            </div>
        </>
    );
};
export default App;
